import React from "react";

function Sms() {
  return <div>Sms</div>;
}

export default Sms;
